import { router } from '@inertiajs/react'

import { Button } from '@/components/ui/button'
import { destroyUserSessionPath } from '@/lib/routes'

export function LoggedUserNavbar() {
  return (
    <Button
      className="px-4 py-2"
      onClick={() => router.delete(destroyUserSessionPath())}
      type="button"
      variant="secondary"
    >
      Sign Out
    </Button>
  )
}
